import React, { createContext, ReactNode, useState, useMemo } from 'react';
import { IconSettingsType } from '@/types/OperationResult';

interface OperationResultType {
	title: string;
	description: string;
	iconSettings: IconSettingsType;
}

export interface OperationResultContextType extends OperationResultType {
	setOperationResultContextData: React.Dispatch<React.SetStateAction<OperationResultType>>;
	isOperationResultContextEmpty: boolean;
}

export const OperationResultContext = createContext<OperationResultContextType | undefined>(undefined);

export const emptyOperationResult = {} as OperationResultType;

export default function OperationStatusProvider({ children }: { children: ReactNode }) {
	const [operationResultContextData, setOperationResultContextData] =
		useState<OperationResultType>(emptyOperationResult);

	const contextValue = useMemo(() => {
		if (operationResultContextData) {
			return {
				...operationResultContextData,
				setOperationResultContextData,
				isOperationResultContextEmpty: emptyOperationResult === operationResultContextData,
			};
		}
	}, [operationResultContextData, setOperationResultContextData]);

	return <OperationResultContext.Provider value={contextValue}>{children}</OperationResultContext.Provider>;
}
